import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AsistenciaMenuComponent } from './asistencia-menu.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    AsistenciaMenuComponent
 ],
  declarations: [AsistenciaMenuComponent]
})
export class AsistenciaMenuModule { }
